
import InfoCard from "../components/InfoCard/InfoCard"
import { useEffect, useState } from "react";

const BossContainer = ({}) => {

  const [bosses, setBosses] = useState([]);

  useEffect(() => {
    fetch("/templates/customWeb2/ModulesReact/buildInformationModule/data/bosses.json")
      .then((res) => res.json())
      .then((data) => setBosses(data))
      .catch((err) => console.error("Error cargando bosses.json:", err));
  }, []);

  return (
    <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)", // 3 columnas iguales
        gap: "20px", // espacio entre cartas
        width: "100%"}}>
        {bosses.map((boss) =>(
            <InfoCard
                key={boss.name}
                imgSrc={boss.img}
                spanTag="Boss"
                name={boss.name}
                mapRespawn={boss.map}
                drop={boss.drop}
                respawnTime = {boss.respawn}
                color="rgb(248, 51, 84)"
            />
        ))
        }
    </div>
  )

}

export default BossContainer